import React from 'react'
import { useDispatch } from 'react-redux'
import { useParams } from 'react-router-dom'
import { useStopwatch } from 'react-timer-hook'
import { actions } from '../../ReceivementState'
import { useReceivement } from 'src/hooks/useReceivement'
import { useStore } from 'src/utils/store'
import { Divider, Typography } from '@mui/material'
import * as S from './Watch.styles'

interface WatchProps {
  statusText?: string
}

const Watch: React.FC<WatchProps> = React.memo(({ statusText }) => {
  const dispatch = useDispatch()
  const store = useStore()
  const {
    seconds, minutes, hours, pause,
  } = useStopwatch({ autoStart: true })

  const preventDoubleCallRef = React.useRef(false)

  const { operatorBadge } = useReceivement({ valideOperator: true })

  const { receivementId } = useParams<{ receivementId?: string }>()

  const resolveWaitingTime = React.useCallback(
    () => {
      const { isLoading } = store.getState().app

      if (Number(String(seconds).slice(-1)) === 0 && !!receivementId && !isLoading && !preventDoubleCallRef.current) {
        preventDoubleCallRef.current = true
        dispatch(
          actions.getFinish({
            badge: operatorBadge,
            receivementId,
            onFinishRequest: () => { preventDoubleCallRef.current = false },
          }),
        )
      }
      return `${`0${hours}`.slice(-2)}:${`0${minutes}`.slice(-2)}:${`0${seconds}`.slice(-2)}`
    },
    [store, seconds, receivementId, hours, minutes, dispatch, operatorBadge],
  )

  React.useEffect(
    () => () => {
      pause()
    },
    // Disabled because react timer hook doesn't return memoized functions
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [],
  )

  return (
    <S.Container>
      <Typography variant='h5'>Finalizar Recebimento: {receivementId}</Typography>
      <Typography variant='h5' fontWeight={600}>{statusText}</Typography>
      <Typography variant='h5' fontWeight={600}>Tempo Aguardando: {resolveWaitingTime()}</Typography>
      <Divider />
    </S.Container>
  )
})

export { Watch }
